import apiClient from "../api/apiClient";

/* ---------- Get Branch / Course / Batch Masters ---------- */
export const getGroupMasters = async (groupId) => {
  const res = await apiClient.get(
    `/admin/group/masters`,
    { params: { groupId } }
  );
  return res.data;
};

/* ---------- Save Student ---------- */
export const saveStudent = async (payload) => {
  const res = await apiClient.post(
    `/admin/students/onboard`,
    payload
  );
  return res.data;
};

export const fetchStudentList = async () => {
  return apiClient.get("/student/list");
};

export const createStudent = async (payload) => {
  return apiClient.post("/student/create", payload);
};

export const getStudentsList = async (payload) => {
  const res = await apiClient.post("/admin/students/list", payload);
  return res.data;
};

export const updateStudent = async (payload) => {
  return apiClient.post("/student/update", payload);
};

export const deleteStudent = async (id) => {
  return apiClient.post(`/student/delete/${id}`);
};
